@if (widget(); as widget) {
  @switch (widget.widgetType) {
    @case ('text') {
      @if (guidelineViewMode() === 'editImportedGuideline') {
        <tt-compare-text-widget
          [isCompareMode]="mergeConflictStatus() === 'conflict' || isCompareMode()"
          [isEditMode]="isEditMode()"
          [mergeConflictStatus]="mergeConflictStatus()"
          [widget]="widget"
          (resolveMergeConflict)="handleResolveMergeConflict()"
          (unresolveMergeConflict)="handleUnresolveMergeConflict()" />
      } @else {
        <tt-text-widget [widget]="widget" />
      }
    }
    @case ('component-list') {
      @if (guidelineViewMode() === 'editImportedGuideline') {
        <tt-compare-component-list-widget [allowEditTags]="allowEditTags()" [expandStrategy]="expandStrategy()" [widget]="widget" />
      } @else {
        <tt-component-list-widget [allowEditTags]="allowEditTags()" [expandStrategy]="expandStrategy()" [widget]="widget" />
      }
    }
    @case ('flowchart') {
      <tt-flowchart-widget
        [flowchartTitle]="chapterTitle() ?? ''"
        [isCompareMode]="hasLocalChanges() && (mergeConflictStatus() === 'conflict' || isCompareMode())"
        [isEditMode]="isEditMode()"
        [mergeConflictStatus]="mergeConflictStatus()"
        [widget]="widget"
        (resolveMergeConflict)="handleResolveMergeConflict()"
        (unresolveMergeConflict)="handleUnresolveMergeConflict()" />
    }
    @case ('workflow') {
      @if (guidelineViewMode() === 'editImportedGuideline' || (guidelineData() | isConnectedGuideline)) {
        <tt-no-results
          [actionIcon]="'plus'"
          [icon]="'file-x-2'"
          [size]="'small'"
          [title]="'WorkflowWidget.ImportedNotAvailable' | transloco" />
      } @else {
        <tt-workflow-widget [widget]="widget" />
      }
    }
  }
}
